export { renderSkeletonItem_unstable as renderSkeletonItem } from '@fluentui/react-skeleton';
